// extracted by mini-css-extract-plugin
export default {"external":"amDf6m","plate":"bmDf6m"};